import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadingIcon from "@mui/icons-material/Downloading";
import { useStoreFileViewerContext } from "../../hooks/context";
import { parseErrorFromPangea } from "../../utils";
import DeleteFileButton from "../DeleteFileButton";
import RenameFileIconButton from "../UpdateFileButton/RenameFileIconButton";
import { downloadFile } from "../../utils/file";
var DownloadFileOptions = function (_a) {
    var data = _a.data;
    var theme = useTheme();
    var apiRef = useStoreFileViewerContext().apiRef;
    var _b = useState(false), downloading = _b[0], setDownloading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var handleDownloadFile = function () {
        if (downloading)
            return;
        setDownloading(true);
        return downloadFile(data, apiRef)
            .then(function () {
            setDownloading(false);
            setError(null);
        })
            .catch(function (err) {
            setError(parseErrorFromPangea(err));
            setDownloading(false);
        });
    };
    if (!data.id)
        return null;
    return (_jsxs(Stack, { direction: "row", spacing: 0.5, alignItems: "center", children: [!!(apiRef === null || apiRef === void 0 ? void 0 : apiRef.update) && _jsx(RenameFileIconButton, { object: data }), !!(apiRef === null || apiRef === void 0 ? void 0 : apiRef.delete) && _jsx(DeleteFileButton, { object: data, view: "icon" }), _jsx(Tooltip, { title: error, children: _jsx(IconButton, { onClick: handleDownloadFile, children: downloading ? (_jsx(DownloadingIcon, { sx: { color: theme.palette.text.primary } })) : (_jsx(DownloadIcon, { color: !!error ? "error" : undefined, sx: { color: theme.palette.text.primary } })) }) })] }));
};
export default DownloadFileOptions;
